import React from 'react'
import tinymce from 'tinymce/tinymce'
import { Editor } from '@tinymce/tinymce-react';
import FileManager from "components/filemanager/file-manager";
import { isImageFile } from './filemanager/filemanager-utils';

const language_maps = {
	'pt-pt': 'pt_PT',
	'de-de': 'de'
}

const globalConfig = {
	theme: 'silver',
	skin: 'oxide',
	plugins:
		//'image code link image table code'
		//'preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen image link media codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons code',
		'preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen image link media codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount noneditable help charmap quickbars emoticons code',
	suffix: '.min',
	image_title: true,
	/* enable automatic uploads of images represented by blob or data URIs*/
	automatic_uploads: true,
	entity_encoding: 'raw',
	file_picker_types: 'image',
	branding: false,
	menubar: false,
	statusbar: false,
	toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify |  |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview print | fileManager image media link anchor codesample | code',
	toolbar_mode: "sliding",
	quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
	contextmenu:  false, //'link image imagetools table configurepermanentpen',
	browser_spellcheck: true,
	tinycomments_mode: 'embedded',
	height: 500,
	file_picker_callback: (cb, value, meta) => {
		const el_picker = document.createElement('input');

		el_picker.setAttribute('type', 'file');
		el_picker.setAttribute('accept', 'image/*');
		el_picker.onchange = function(e) {
			const file = e.currentTarget.files[0];
			const reader = new FileReader();
			reader.onload = () => {
				const id = 'blobid' + (new Date()).getTime();
				const blobCache =  tinymce.activeEditor.editorUpload.blobCache;
				const base64 = reader.result.split(',')[1];
				const blobInfo = blobCache.create(id, file, base64);

				blobCache.add(blobInfo);

				/* call the callback and populate the Title field with the file name */
				cb(blobInfo.blobUri(), { title: file.name });
				//el_picker = null;
			};
			reader.readAsDataURL(file);
		};
		el_picker.click();
		el_picker.remove();
	},
}

tinymce.baseURL = hp.settings.tpldns + 'admin/tinymce/react'
if (hp.settings.locale) {
	globalConfig.language = language_maps[hp.settings.locale];
	globalConfig.language_url = tinymce.baseURL + '/langs/' + hp.settings.locale + '.js';
}

export default class HtmlEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state =  {
			selectedFiles: [],
			currentHtmlEditor: {}
		}

		let { tags } = this.props

		this.config = {}
		if (tags) {
			this.config.toolbar =  globalConfig.toolbar + " | tags"
			this.config.init = (editor) => {
				editor.ui.registry.addMenuButton('tags', {
					text: 'Tags',
					fetch: function(callback) {
						const items = []
						tags = typeof tags === 'string' ? JSON.parse(tags) : tags
						for (const [key, label] of Object.entries(tags)) {
							items.push({type: 'menuitem', text: label, onAction: (e) => {
								editor.insertContent(key);
							}})
						}
						callback(items)
					},
					onAction: function(e) {
						editor.insertContent(this.value());
					}
				});
			}
		}
	}

	handleEditorChange = (content) => {
		if (!tinymce.activeEditor.hasFocus()) {
			return
		}
		//if (this.previous_value == content) {
		//	return;
		//}
		//this.previous_value = content;
		if (this.props.model) {
			this.props.model[this.props.name] = content;
		}
		if (this.props.onChange) {
			this.props.onChange(content);
		}
		this.forceUpdate()
	}

	getValue() {
		return this.props.initValue || (this.props.model ? this.props.model[this.props.name] : '') || '';
	}

	addSelectedFileToHtml = () => {
		const { selectedFiles, currentHtmlEditor } = this.state
		selectedFiles.forEach(file => {
			if (file && currentHtmlEditor) {
				let content = `<a href="${file.url}" target="_blank">${file.url}</a>`;
				
				if(isImageFile(file)) {
					content = `<img src="${file.url}" alt="Imagem"/>`;
				}
	
				currentHtmlEditor.insertContent(content);
			}
		});

		mbox.dismiss();
	}

	openFileManager = async (editor) => {
		http.get('/filesmanager/initFileManager.json', {}, () => {
			mbox.modal(
				<FileManager 
					isFromEditor={true}  
					onSelected={selectedFiles => this.setState({selectedFiles, currentHtmlEditor: editor})}
				/>,
				{ 
					buttons: [
						'close',
						{
							text: __('buttons_add'), 
							icon: 'la la-check', 
							type: 'primary',
							onClick: this.addSelectedFileToHtml
						}
					]
				}
			)
        })
	}

	render() {
		const config = Object.assign({}, globalConfig, this.config,
			{
				height: this.props.height || globalConfig.height,
				setup: editor => {
					editor.ui.registry.addButton('fileManager', {
						icon: 'upload',
						tooltip: 'Inserir ficheiros através do Explorador de Ficheiros',
						onAction: () => {
							this.openFileManager(editor);
						}
					});
					if (this.config.init) {
						this.config.init(editor)
					}
					this.setState({activeEditor: editor})
				}
			},
			this.props.config || null
		)
		return (
			<Editor
				value={this.getValue()}
				init={config}
				onEditorChange={this.handleEditorChange}
			/>
		);
	}

	static setSaved() {
		return tinymce.activeEditor ? tinymce.activeEditor.save() : null
	}

	//componentDidUpdate(prevProps) {
		//	tinymce.activeEditor.startContent = tinymce.activeEditor.getContent({format: 'raw'})
		/*
		// update content only if value changes
		if (tinymce.activeEditor && (this.previous_value === null || this.previous_value != this.getValue())) {
			tinymce.activeEditor.setContent(this.previous_value = this.getValue());
		}
		*/
	//}
}
